import React from 'react';

const DEFAULT_STATE = {};

export const NotificadorContext = React.createContext(DEFAULT_STATE);
